import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreService } from '@morningstar/shared/base/base-service';
import { environment } from '@morningstar/shared/environment';
import { MeetingAttendee } from '@morningstar/shared/meeting-attendees';
import { KeyValuePair } from '@morningstar/shared/models';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MeetingRoomRequirements } from './meeting-room-requirements/meeting-room-requirements';
import { MeetingRoomUtilization } from './meeting-room-utilization/meeting-room-utilization';
import { MeetingRoomSelectors } from './meeting-room.selectors';

@Injectable()
export class MeetingRoomService extends StoreService {

  processingArrival = new Subject<string | number>();
  processingArrival$ = this.processingArrival.asObservable();

  constructor(protected httpClient: HttpClient,
              snackbar: MatSnackBar,
              @Inject('API_BASE_URL') private baseHref) {
    super(httpClient, baseHref, snackbar);
  }

  getUtilization(location: string) {
    return this.httpClient.get<MeetingRoomUtilization[]>(this.baseHref + environment.api.dashboard.meetingRooms.utilization.replace('{location}', location));
  }

  getRequirements(location: string, date: Date) {
    // include current time if today's date
    if(date.toLocaleDateString() === new Date().toLocaleDateString()){
      date = new Date();
    }

    const formattedDate = formatDate(date, 'yyyy-MM-dd hh:mm a', 'en-US');
    const endpoint = `dashboard/meeting-rooms/requirements/${location}/date/${formattedDate}`

    this.readList<MeetingRoomRequirements>(MeetingRoomSelectors.meetingRoomRequirements, endpoint, 'requirements')
        .subscribe();
  }

  getAttendance(location: string) {
    const endpoint = 'dashboard/meeting-attendance/{id}';
    const params = [ new KeyValuePair('{id}', location) ];

    this.readList(MeetingRoomSelectors.attendance, endpoint, 'attendance', params).subscribe();
  }

  markArrived(attendee: MeetingAttendee, location: string) {
    this.processingArrival.next(attendee.id);
    const endpoint = 'scheduler/meeting/attendees/mark-arrived';

    this.create({ids: [attendee.id]}, endpoint, 'attendee').pipe(
      tap(_ => {
        this.processingArrival.next(null);
        this.getAttendance(location);
      })
    ).subscribe();
  }
}
